import { apiEmpleo } from "../../util/ApiEmpleo";
import { TServiceState } from "./service.types";

export type TUpdateServiceRequest = {
  Estado_Servicio?: TServiceState;
  Source?: string;
  Observaciones1?: string;
  Otras_notas_valoracion?: string;
  Horario_Servicio?: string;
  Tareas_solicitadas?: string[];
  Sexo_trabajador?: string;
  Usuario1?: string;
  Salario_Bruto?: number;
  Tipo_de_salario?: string;
  Fecha_inicio_servicio?: string;
  Fecha_objetivo_entrevistas?: string;
  Horas_jornada_semanal?: number;
  Descanso_semanal?: string;
  Cl_usulas_especiales?: string;
  Titulaci_n_oficial?: string;
  Usuarios_a_cuidar?: number;
  Direccion_entrega_Cuideo_Asist_distinta_servicio?: string;
  Ciudad_entrega_Cuideo_Asist?: string | null;
  Codigo_postal_entrega_Cuideo_Asist?: string | null;
  Direccion_entrega_Cuideo_Asist?: string | null;
  Region_entrega_Cuideo_Asist?: string | null;
  Area_entrega_Cuideo_Asist?: string | null;
  Latitud_entrega_Cuideo_Asist?: string | null;
  Longitud_entrega_Cuideo_Asist?: string | null;
  Utilizar_usuario_existente_o_crear_nuevo?:
    | "Crear nuevo"
    | "Utilizar existente"
    | "Ya solicitado"
    | null;
  Usuario?: string | null;
  Informe_general_inicial?: string | null;
  Inicio_de_servicio?: string | null;
  Activar_Servicio_Cuideo_Asist?: boolean | null;
  Seguimiento_datetime?: string | null;
  Enviar_resumen_valoracion?: boolean;
  Rutinas?: string | null;
};

const apiUpdateService = async (
  serviceId: string,
  service: TUpdateServiceRequest
) => {
  if (service.Usuario1) {
    service.Usuario1 = `/api/service_holders/${service.Usuario1}`;
  }
  if (service.Usuario) {
    service.Usuario = `/api/employers/${service.Usuario}`;
  }

  let res = await apiEmpleo.patch(`services/${serviceId}`, service, {
    headers: {
      "Content-Type": "application/merge-patch+json",
    },
  });

  return res;
};

export { apiUpdateService };
